import { render, staticRenderFns } from "./ProjectProposition.vue?vue&type=template&id=3482bd89&"
import script from "./ProjectProposition.vue?vue&type=script&lang=js&"
export * from "./ProjectProposition.vue?vue&type=script&lang=js&"
import style0 from "./ProjectProposition.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports